import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const city = params.get("city") ?? "";
  const sort = params.get("sort") ?? "Recommended";

  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-8 grid gap-6 md:grid-cols-[260px_1fr]">
      <Helmet>
        <title>Search | FANZ</title>
        <meta name="description" content="Search creators with city, price, and availability facets." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/search'} />
      </Helmet>

      <aside className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Location</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Input
              placeholder="City"
              value={city}
              onChange={(e) => {
                params.set("city", e.target.value);
                setParams(params, { replace: true });
              }}
            />
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Sort</CardTitle>
          </CardHeader>
          <CardContent>
            <Select
              value={sort}
              onValueChange={(v) => {
                params.set("sort", v);
                setParams(params, { replace: true });
              }}
            >
              <SelectTrigger><SelectValue placeholder="Sort" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="Recommended">Recommended</SelectItem>
                <SelectItem value="Newest">Newest</SelectItem>
                <SelectItem value="Closest">Closest</SelectItem>
                <SelectItem value="Top Rated">Top Rated</SelectItem>
                <SelectItem value="Trending">Trending</SelectItem>
              </SelectContent>
            </Select>
          </CardContent>
        </Card>
      </aside>

      <section className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Featured Row</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">Spotlight placements appear here.</CardContent>
        </Card>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 12 }).map((_, i) => (
            <Card key={i} className="aspect-[3/4]" />
          ))}
        </div>
      </section>
    </main>
  );
}
